import { Feedback, Skeleton } from '@welbe/web-design-system';
import React from 'react';

import { CategoryCard } from './components/CategoryCard/CategoryCard';
import { MainCard } from './components/MainCard/MainCard';
import { Container, ContainerSkeleton, ContainerCards } from './Content.styles';

interface ContentProps {
	data: any;
	isLoading?: boolean;
	selectedCommunication: any;
	companyName?: any;
	branchOfficeName?: any;
	sector?: any;
}

export const Content = ({
	data,
	isLoading,
	selectedCommunication,
	companyName,
	branchOfficeName,
	sector,
}: ContentProps) => {
	const { categories, questionnaire } = data;

	if (isLoading) {
		return (
			<ContainerSkeleton>
				<Skeleton />
				<Skeleton />
				<Skeleton />
			</ContainerSkeleton>
		);
	}

	if (!categories?.length || !questionnaire) {
		return (
			<ContainerSkeleton>
				<Feedback
					message="
					No se encontraron resultados para estos filtros."
				/>
			</ContainerSkeleton>
		);
	}

	return (
		<Container>
			<MainCard
				selectedCommunication={selectedCommunication}
				companyName={companyName}
				branchOfficeName={branchOfficeName}
				sector={sector}
				questionnaire={questionnaire}
			/>
			<ContainerCards>
				{categories?.map((category: any) => (
					<CategoryCard key={category.id} category={category} />
				))}
			</ContainerCards>
		</Container>
	);
};
